// The period presets of the work orders' dashboards.
const iso = (d) => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`

// The period presets of the work orders' dashboards -> { desde, hasta } (ISO dates).
export function rangoDe(clave, hoy = new Date()) {
  const h = new Date(hoy.getFullYear(), hoy.getMonth(), hoy.getDate())
  const menos = (n) => { const d = new Date(h); d.setDate(d.getDate() - n); return d }
  if (clave === 'semana') {
    const lunes = menos((h.getDay() + 6) % 7)
    return { desde: iso(lunes), hasta: iso(h) }
  }
  if (clave === 'mes') return { desde: iso(new Date(h.getFullYear(), h.getMonth(), 1)), hasta: iso(h) }
  if (clave === '90') return { desde: iso(menos(89)), hasta: iso(h) }
  return { desde: iso(menos(29)), hasta: iso(h) }            // '30'
}
